import { Injectable } from "@angular/core";

import { RestService } from "../core/core/rest.service";
import { ObjectToSelect } from "../core/shared/objectToSelect.model";
import { Absence, AbsenceHistory, AbsenceAction, AbsenceCurrentUser, AbsenceRow, AbsenceNotificationEmployee } from "./absences.model";
import { GridMainFilter } from "../core/shared/grid/grid.model";
import { Observable } from "rxjs";
import { CalendarBundle } from "../core/shared/calendar/calendar.model";

@Injectable()
export class AbsencesRest {

  constructor(private http: RestService) {
  }

  public getEmployeesToSelect() {
    return this.http.get<ObjectToSelect[]>('api/absences/employees');
  }

  public getUserEmployeesToSelect() {
    return this.http.get<ObjectToSelect[]>('api/absences/absence/employees');
  }

  public deleteAbsence(absenceId: number, currentEmployeeId: number) {
    return this.http.post(`api/absences/delete/${currentEmployeeId}`, absenceId);
  }

  public deleteSelectedAbsences(selectedAbsenceIds: number[], currentEmployeeId: number) {
    return this.http.post(`api/absences/deleteSelected/${currentEmployeeId}`, selectedAbsenceIds);
  }

  public saveAbsence(absence: Absence, withInit: boolean) {
    return this.http.post(`api/absences/absence/save/${withInit}`, absence);
  }

  public getAbsenceHistory(id: number) {
    return this.http.get<AbsenceHistory[]>(`api/absences/absence/history/${id}`);
  }

  public getAbsence(id: number) {
    return this.http.get<Absence>(`api/absences/absence/${id}`);
  }

  public getAbsencesForCalendar(mainFilter: GridMainFilter[]) {
    return this.http.post<CalendarBundle>(`api/absences/calendar`, mainFilter);
  }

  public getEmptyAbsence() {
    return this.http.get<Absence>(`api/absences/absence/add`);
  }

  public changeAbsenceStateForMany(absenceIds: number[], action: AbsenceAction, currentEmployeeId: number) {
    return this.http.post(`api/absences/absence/changestate/${action}/${currentEmployeeId}`, absenceIds);
  }

  public changeAbsenceState(absenceId: number, action: AbsenceAction, currentEmployeeId: number) {
    return this.http.get<Boolean>(`api/absences/absence/changestate/${absenceId}/${action}/${currentEmployeeId}`);
  }

  public getAbsenceCurrentUser(employeeId: number) {
    return this.http.get<AbsenceCurrentUser>(`api/absences/absence/getcurrentuser/${employeeId}`);
  }

  public removeNotificationEmployee(notificationEmployeeId: number) {
    return this.http.post(`api/absences/removeNotificationEmployee/${notificationEmployeeId}`, {});
  }

  public addNotificationEmployee(notificationEmployeeId: number, absenceId: number) {
    return this.http.post<AbsenceNotificationEmployee>(`api/absences/addNotificationEmployee/${absenceId}/${notificationEmployeeId}`, {});
  }
}